import PropTypes from 'prop-types';
import React from 'react';

const InputOptionCard = ({
  name,
  label,
  options,
  error,
  onChange,
  isDisabled,
  value,
}) => (
  <div className={'ccfp__content__form__input-option-card'}>
    <div
      className={`ccfp__content__form__input-option-card__label ${
        error ? 'ccfp__content__form__input-option-card__label--has-error' : ''
      }`}
    >
      <label htmlFor={name}>{label}</label>
    </div>
    <div className={'ccfp__content__form__input-option-card__options'}>
      <div className={'wrapper'}>
        {options.map((option, index) => (
          <div
            className={`ccfp__content__form__input-option-card__options__option ${
              error
                ? 'ccfp__content__form__input-option-card__options__option--has-error'
                : ''
            }`}
            key={index}
          >
            <input
              type={'radio'}
              onChange={e => onChange(e)}
              name={name}
              id={option.code}
              value={option.code}
              disabled={isDisabled}
              defaultChecked={value === option.code}
            />
            <label htmlFor={option.code}>
              <img src={option.image} role={'presentation'} />
            </label>
          </div>
        ))}
      </div>
      <p className={'error-text'}>{error}</p>
    </div>
  </div>
);

InputOptionCard.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      image: PropTypes.string,
    }),
  ).isRequired,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

export default InputOptionCard;
